import { incidentAlertColor } from "./utils";
import { checkPermission } from "../utils/Roles";
import moment from "moment";

//The idNames need to match the row names in parseInactiveIncidents
export const inactiveIncidentHeaders = [
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Badge", idName: "badges", show: true },
  { title: "Assign", idName: "assignments", show: true },
  { title: "Type", idName: "type", show: true },
  { title: "Location", idName: "location", show: true },
  { title: "Started", idName: "callTime", show: true },
  { title: "Cleared", idName: "clearedAts", show: true },
  { title: "Car\xa0#", idName: "carNumbers", show: true },
  { title: "Radio\xa0#", idName: "radioNumbers", show: true },
];

export function parseInactiveIncidents(arr, clickHandler, userRoles) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incident) => {
      const {
        id: incidentId,
        officerIncidentSpecifics,
        classification,
        address,
        locked,
        sealed,
      } = incident;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const callTypeColor = incidentAlertColor(incident, true, false, false);
      const locationColor = incidentAlertColor(incident, false, true, false);
      const clearedOiss = officerIncidentSpecifics?.filter(
        ois => ois?.clearedAt
      );
      const canViewLocked = checkPermission(
        userRoles,
        "view_locked_incident",
        "ALL",
        "",
        incidentId
      );
      const canViewSealed = checkPermission(
        userRoles,
        "view_sealed_incident",
        "ALL",
        "",
        incidentId
      );
      const disabled =
        (!canViewLocked && locked) || (!canViewSealed && sealed) ? true : false;
      // const incidentNumber = <button style={{backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textDecoration: 'underline', display: 'inline', margin: '0', padding: '0', }} data-cy={"tablecell-incident-number-link-" + incidentId} onClick={() => { clickHandler(incidentId, true) }}>{incident.incidentNumber}</button>
      const incidentNumber = (
        <button
          style={
            disabled
              ? {
                  backgroundColor: "transparent",
                  color: "#7d7d7d",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  border: "none",
                  display: "inline",
                  margin: "0",
                  padding: "0",
                  "&:hover": {
                    textDecoration: "none",
                  },
                  "&:focus": {
                    textDecoration: "none",
                  },
                }
              : {
                  backgroundColor: "transparent",
                  color: "#6096d1",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  border: "none",
                  cursor: "pointer",
                  textDecoration: "underline",
                  display: "inline",
                  margin: "0",
                  padding: "0",
                  "&:hover": {
                    textDecoration: "none",
                  },
                  "&:focus": {
                    textDecoration: "none",
                  },
                }
          }
          data-cy={"tablecell-incident-number-link-" + incidentId}
          onClick={
            disabled
              ? () => alert("You do not have permission to view this incident")
              : () => {
                  clickHandler(incidentId, true);
                }
          }
        >
          {incident.incidentNumber}
        </button>
      );
      const badges = clearedOiss
        .map(ois => ois?.officer?.deptAttribute?.badge)
        ?.join("|");
      const assignments = clearedOiss
        .map(ois => ois?.officer?.deptAttribute?.assignment)
        ?.join("|");
      const radioNumbers = clearedOiss
        .map(ois => ois?.officer?.deptAttribute?.radioNumber)
        ?.join("|");
      const carNumbers = clearedOiss
        .map(ois => ois?.officer?.deptAttribute?.carNumber)
        ?.join("|");
      const officerIds = clearedOiss.map(ois => ois?.officer?.id)?.join("|");
      const deptAttrIds = clearedOiss
        .map(ois => ois?.officer?.deptAttribute?.id)
        ?.join("|");
      const clearedAts = clearedOiss
        .map(ois =>
          moment
            .utc(ois?.clearedAt, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        )
        ?.join("|");
      const oisIds = clearedOiss.map(ois => ois?.id)?.join("|");

      const type = classification ? classification.name : null;
      const location = address ? address.name : null;
      tempRows.push(
        createData(
          oisIds,
          incidentNumber,
          badges,
          assignments,
          type,
          location,
          callTime,
          clearedAts,
          carNumbers,
          radioNumbers,
          officerIds,
          incidentId,
          deptAttrIds,
          callTypeColor,
          locationColor
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createData(
  oisIds,
  incidentNumber,
  badges,
  assignments,
  type,
  location,
  callTime,
  clearedAts,
  carNumbers,
  radioNumbers,
  officerIds,
  incidentId,
  deptAttrIds,
  callTypeColor,
  locationColor
) {
  return {
    oisIds,
    incidentNumber,
    badges,
    assignments,
    type,
    location,
    callTime,
    clearedAts,
    carNumbers,
    radioNumbers,
    officerIds,
    incidentId,
    deptAttrIds,
    callTypeColor,
    locationColor,
  };
}
